import axios from 'axios';
import { mockApiService } from '../data/mockData';

// Configuración base de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const USE_MOCK_DATA = process.env.REACT_APP_USE_MOCK_DATA === 'true' || !process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Importante para cookies CSRF con Sanctum
});

// Recuperar token del localStorage si existe
const token = localStorage.getItem('auth_token');
if (token) {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Interceptor para manejo de errores
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    if (error.response) {
      // Error del servidor
      const message = error.response.data?.message || 'Error del servidor';
      throw new Error(`${error.response.status}: ${message}`);
    } else if (error.request) {
      // Error de red
      throw new Error('Error de conexión. Verifica tu conexión a internet.');
    } else {
      // Error de configuración
      throw new Error('Error en la configuración de la solicitud');
    }
  }
);

// Servicio para clientes
export const clientesService = {
  // Obtener todos los clientes
  async getAll() {
    if (USE_MOCK_DATA) {
      return await mockApiService.getClientes();
    }
    
    try {
      const response = await apiClient.get('/clientes');
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(`Error al obtener clientes: ${error.message}`);
    }
  },

  // Obtener cliente por ID
  // async getById(id) {
  //   try {
  //     const response = await apiClient.get(`/clientes/${id}`);
  //     return response.data.data || response.data;
  //   } catch (error) {
  //     throw new Error(`Error al obtener cliente: ${error.message}`);
  //   }
  // },

  // Reasignar vendedor a múltiples clientes
  async reasignarVendedor(clienteIds, nuevoVendedorId, notas, vendedorActualId) {
    if (USE_MOCK_DATA) {
      return await mockApiService.reasignarVendedor(clienteIds, nuevoVendedorId, notas);
    }
    
    try {
      const payload = {
        cliente_ids: clienteIds,
        nuevo_vendedor_id: nuevoVendedorId,
        notas,
      };
      // Incluir vendedor de origen cuando está disponible para afectar solo esa relación
      if (typeof vendedorActualId !== 'undefined' && vendedorActualId !== null) {
        payload.vendedor_actual_id = vendedorActualId;
      }

      const response = await apiClient.post('/clientes/reasignar-vendedor', payload);
      return response.data;
    } catch (error) {
      throw new Error(`Error al reasignar vendedor: ${error.message}`);
    }
  },

  // Actualizar día/frecuencia/semana de visita
  async actualizarVisitas(detalles, notas, vendedorActualId) {
    if (USE_MOCK_DATA) {
      // El mock no requiere vendedor_actual_id separado
      return await mockApiService.actualizarVisitas(detalles, notas);
    }

    try {
      const payload = { notas, vendedor_actual_id: vendedorActualId, detalles };
      const response = await apiClient.post('/clientes/actualizar-visitas', payload);
      return response.data;
    } catch (error) {
      throw new Error(`Error al actualizar visitas: ${error.message}`);
    }
  },

  // Resumen de pendientes (reasignaciones y cambios de visita)
  async getResumenPendientes() {
    if (USE_MOCK_DATA) {
      return { reasignaciones_pendientes: 0, cambios_visita_pendientes: 0 };
    }

    try {
      const response = await apiClient.get('/clientes/resumen-pendientes');
      return response.data?.data || response.data;
    } catch (error) {
      throw new Error(`Error al obtener resumen de pendientes: ${error.message}`);
    }
  },

  // Buscar clientes por criterios
  // async search(filters) {
  //   try {
  //     const params = new URLSearchParams();
      
  //     if (filters.vendedor) params.append('vendedor', filters.vendedor);
  //     if (filters.zona) params.append('zona', filters.zona);
  //     if (filters.dia) params.append('dia', filters.dia);
  //     if (filters.busqueda) params.append('busqueda', filters.busqueda);

  //     const response = await apiClient.get(`/clientes/search?${params.toString()}`);
  //     return response.data.data || response.data;
  //   } catch (error) {
  //     throw new Error(`Error en la búsqueda: ${error.message}`);
  //   }
  // }
};

// Servicio para vendedores
export const vendedoresService = {
  // Obtener todos los vendedores
  async getAll() {
    if (USE_MOCK_DATA) {
      return await mockApiService.getVendedores();
    }
    
    try {
      const response = await apiClient.get('/vendedores');
      return response.data.data || response.data;
    } catch (error) {
      throw new Error(`Error al obtener vendedores: ${error.message}`);
    }
  },

  // Obtener vendedor por ID
  // async getById(id) {
  //   try {
  //     const response = await apiClient.get(`/vendedores/${id}`);
  //     return response.data.data || response.data;
  //   } catch (error) {
  //     throw new Error(`Error al obtener vendedor: ${error.message}`);
  //   }
  // },

  // Obtener estadísticas de vendedores
  // async getEstadisticas() {
  //   try {
  //     const response = await apiClient.get('/vendedores/estadisticas');
  //     return response.data.data || response.data;
  //   } catch (error) {
  //     throw new Error(`Error al obtener estadísticas: ${error.message}`);
  //   }
  // }
};

// Servicio de configuración (empresa)
export const configService = {
  async getEmpresa() {
    if (USE_MOCK_DATA) {
      return {
        nombre: 'GeoClientes',
        logo_url: null,
        favicon_url: null,
        color_primario: '#2c3e50',
      };
    }

    try {
      const response = await apiClient.get('/empresa');
      return response.data;
    } catch (error) {
      throw new Error(`Error al obtener configuración: ${error.message}`);
    }
  },
};

export default apiClient;
